import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";

const TRACK_LINKS = [
  { label: "Roadmap", section: "roadmap" },
  { label: "All ten courses", section: "courses" },
  { label: "Cyber range", section: "labs" },
  { label: "Pricing", section: "enroll" },
];

const SERVICES_LINKS = [
  { label: "Penetration Testing", to: "/services/penetration-testing" },
  { label: "GRC", to: "/services/grc" },
  { label: "Cyber Maturity", to: "/services/cybersecurity-maturity-assessment" },
  { label: "Data Privacy", to: "/services/data-privacy" },
];

const COMPANY_LINKS = [
  { label: "About", to: "/services/#about" },
  { label: "For Startups", to: "/services/cybersecurity-for-startups" },
  { label: "For AI", to: "/services/cybersecurity-for-ai" },
  { label: "Contact", to: "/services/#contact" },
];

const Footer = () => {
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        const navbarHeight = 120;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: elementPosition - navbarHeight, behavior: "smooth" });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="border-t border-[#18181b]">
      <div className="max-w-[1200px] mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5 mb-3.5">
            <Link to="/" className="flex items-center gap-2.5">
              <img src={logo} alt="Hack Defense" className="h-7 w-auto" />
            </Link>
          </div>
          <p className="text-[14px] text-[#71717a] leading-[1.7] max-w-[280px] mb-4">
            Fully online cybersecurity training built by practitioners. Recorded video and hands-on labs, studied by students across Asia, the GCC, Europe, North America and Africa.
          </p>
          <a
            href="mailto:contact@hackdefense.org"
            className="text-[14px] text-[#a1a1aa] hover:text-white transition-colors"
          >
            contact@hackdefense.org
          </a>
        </div>

        {/* Track */}
        <div>
          <div className="font-mono text-[11px] text-[#52525b] mb-3.5" style={{ letterSpacing: "0.14em" }}>
            TRACK
          </div>
          <div className="grid gap-2.5">
            {TRACK_LINKS.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.section)}
                className="text-[14px] text-[#a1a1aa] hover:text-white transition-colors text-left"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <div className="font-mono text-[11px] text-[#52525b] mb-3.5" style={{ letterSpacing: "0.14em" }}>
            SERVICES
          </div>
          <div className="grid gap-2.5">
            {SERVICES_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="text-[14px] text-[#a1a1aa] hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Company */}
        <div>
          <div className="font-mono text-[11px] text-[#52525b] mb-3.5" style={{ letterSpacing: "0.14em" }}>
            COMPANY
          </div>
          <div className="grid gap-2.5">
            {COMPANY_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="text-[14px] text-[#a1a1aa] hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#18181b]">
        <div className="max-w-[1200px] mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-[12px] text-[#52525b]">
            &copy; {new Date().getFullYear()} Hack Defense. All rights reserved.
          </span>
          <span className="text-[12px] text-[#52525b]">
            contact@hackdefense.org
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
